import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  q: '⚙️ ¿Sirve para cualquier provincia de Argentina?',
  a: 'Sí. Todo el contenido está en español y aplica a operaciones mineras en todo el territorio nacional.'
}, {
  q: '📩 ¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibís un email con el link a tu Google Drive. En menos de 5 minutos tenés acceso a todo.'
}, {
  q: '🔓 ¿Es descargable o solo online?',
  a: 'Podés descargarlo todo a tu computadora. El acceso es ilimitado y de por vida.'
}, {
  q: '💻 ¿Los softwares incluidos funcionan en Windows?',
  a: 'Sí. Todos los softwares son compatibles con Windows. Incluyen guía de instalación.'
}, {
  q: '🔄 ¿Hay actualizaciones?',
  a: 'Sí. Recibís todas las actualizaciones futuras sin costo adicional.'
}, {
  q: '💳 ¿Puedo pagar en cuotas?',
  a: 'Sí. Con tarjeta de crédito podés elegir cuotas directamente en Mercado Pago.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-white" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <h2 className="text-4xl font-black text-center text-brand-dark mb-12" data-id="element-76">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-77">
          {faqs.map((faq, index) => <div key={index} className="border-2 border-gray-100 rounded-xl overflow-hidden shadow-sm" data-id="element-78">
              <button className="w-full px-6 py-5 text-left bg-gray-50 hover:bg-gray-100 transition-colors flex justify-between items-center" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-79">
                <span className="font-bold text-lg text-brand-dark pr-4" data-id="element-80">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-6 h-6 text-brand-orange flex-shrink-0" data-id="element-81" /> : <ChevronDownIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-82" />}
              </button>

              {openIndex === index && <div className="px-6 py-5 bg-white text-gray-700 text-lg leading-relaxed border-t border-gray-100" data-id="element-83">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}